import React, { useEffect, useRef, useState } from 'react';
import jsQR from 'jsqr';
import { useNavigate } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from 'moment';
import axios from 'axios';

let { lambda, appname } = window.app;

const ScannerComponent = ({ countsData, onScanChange, defaultstoreCounts }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const animationIdRef = useRef(null);
  const scanned = useRef(false);

  const navigate = useNavigate();
  const [scannedData, setScannedData] = useState(null);
  const [checkinData, setCheckinData] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [tableErrMsg, setTableErrMsg] = useState(false);
  const [tableErrMsg1, setTableErrMsg1] = useState(false);
  const [invalidBarcode, setInvalidBarcode] = useState(false);
  const [scanError, setScanError] = useState(false);
  const [scanErrorMsg, setScanErrorMsg] = useState("Camera not Allowed Permission denied");



  useEffect(() => {
    startScanner();
    return () => {
      cancelAnimationFrame(animationIdRef.current);
      stopStream();
    };
  }, []);

  const startScanner = async () => {
    onScanChange(false)
    try {
      streamRef.current = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
        audio: false,
      });

      if (videoRef.current) {
        videoRef.current.srcObject = streamRef.current;
        videoRef.current.onloadedmetadata = () => {
          videoRef.current.play();
          animationIdRef.current = requestAnimationFrame(scan);
        };
      }
    } catch (error) {
      console.error('Camera error:', error);
      setScanError(true)
      // setScanErrorMsg(error)
    }
  };

  const stopStream = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
  };

  const isBookingTimeNow = (bookingDateString) => {
    const now = new Date();
    const bookingDate = new Date(bookingDateString);
    let minutes = 15
    // Create range: 10 minutes before and after
    const MinutesBefore = new Date(now.getTime() - minutes * 60 * 1000);
    const MinutesAfter = new Date(now.getTime() + minutes * 60 * 1000);

    return bookingDate >= MinutesBefore && bookingDate <= MinutesAfter;
  };

  const scan = async () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    if (video && canvas && video.videoWidth > 0 && video.videoHeight > 0) {
      const ctx = canvas.getContext('2d');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const code = jsQR(imageData.data, canvas.width, canvas.height);


      if (code && !scanned.current && code?.data) {
        scanned.current = true;

        try {
          const parsedUrl = new URL(code?.data);
          const searchParams = new URLSearchParams(parsedUrl.search);
          const bookingId = searchParams.get("bookingId");
          const guestId = searchParams.get("guestId");
          const token = localStorage.getItem("token");
          const storeid = localStorage.getItem("storeid");

          console.log("parsedUrl ", parsedUrl)

          if (!storeid) {
            setTableErrMsg(true);
            return;
          }

          const response = await axios.get(
            `${lambda}bookingDetails?appname=${appname}&bookingId=${bookingId}&guestId=${guestId}&token=${token}`
          );

          const booking = response?.data?.result?.[0] || [];
          console.log("booking ", booking)
          if (booking && booking.length == 0) {
            setInvalidBarcode(true);
            return;
          }

          if (storeid.trim() !== booking.storeid?.trim()) {
            setTableErrMsg1(true);
            return;
          }

          cancelAnimationFrame(animationIdRef.current);
          stopStream();



          if (isBookingTimeNow(booking?.bookingDate) && booking?.message == "") {
            console.log("Booking time is within the 10-minute window.");
            booking["message"] = ""
          } else if (booking?.message == "") {
            console.log("Booking time is outside the 10-minute window.");
            console.log("Booking time booking.", booking);
            let date = booking?.bookingDate ? moment.utc(booking.bookingDate).format("MM-DD-YYYY") : "";
            let timeOnly = booking?.spotstart ? booking.spotstart : "";
            booking["message"] = `There's still time for you to check in, your spot is scheduled for ${date} at ${timeOnly}.`;

          }

          if (booking?.status == "EXPIRED") {
            booking["message"] = "Booking Expired"
          }

          setScannedData(booking);
          onScanChange(true)
        } catch (error) {
          console.error("Error fetching booking details:", error);
          setInvalidBarcode(true);
          return;
        }
      }
    }

    animationIdRef.current = requestAnimationFrame(scan);
  };

  const scanAgain = (e) => {
    e.preventDefault();
    setSubmitted(false);
    setScannedData(null);
    scanned.current = false;
    startScanner();
    onScanChange(false)
  };

  const checkInAPI = async (item, type) => {
    const guestId = item?.guests?.[0]?.guestId;
    const token = localStorage.getItem("token");
    let storeid = localStorage.getItem("storeid");
    const response = await axios.post(
      `${lambda}updateScanBookings?appname=${appname}&type=${type}&guestId=${guestId}&token=${token}`
    );

    setCheckinData(response?.data?.result?.[0]);
    if (type == "checkIn") {
      setSubmitted(true);
    } else {
      setSubmitted(false);
      setScannedData(null);
      scanned.current = false;
      startScanner();
    }
    defaultstoreCounts(storeid);
  };
  // const defaultstoreCounts = (value) => {
  //   // GetTimeActivity()
  //   const token = localStorage.getItem("token")
  //   const useruniqueid = localStorage.getItem("clientid")
  //   axios({
  //     method: 'GET',
  //     url: `${lambda}storeCounts?appname=${appname}&storeid=${value}&token=${token}`,
  //     // + "&token=" + token,
  //   })
  //     .then(function (response) {
  //       if (response?.data?.result === "Invalid token or Expired") {
  //         // setShowSessionPopupup(true)
  //       } else {
  //         if (response?.data?.result) {
  //           const result = response?.data?.result;
  //           //setCountsData(result)
  //           //  editUser?.companydetails?.[0].accountmanager
  //         }

  //       }

  //       // setDisableSaveBtn(false)
  //     });
  // }
  if (scannedData && !submitted) {
    return (
      <div id="scan-container">
        {(scannedData?.message) ? (
          <div id="scan-message-block">
            {scannedData?.message === "Guest Already Scanned" && scannedData?.guests?.[0]?.checkOutTime !== "" ? (
              <p id="checkout-completed-text" className="checkout-txt">
                Guest already checked out and spot was completed
              </p>
            ) : (
              <p id="scan-message-text" className="checkout-txt">{scannedData?.message}</p>
            )}

            {scannedData?.message === "Guest Already Scanned" && scannedData?.guests?.[0]?.checkOutTime === "" && (
              <p id="ready-checkout-text" className="checkout-txt">Ready to Check-out</p>
            )}

            <div className="col-md-12" id="scan-action-buttons">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-center align-items-center">
                    <button id="scan-again-btn" className="stroke-btn-style me-3" onClick={scanAgain}>
                      SCAN AGAIN
                    </button>

                    {scannedData?.message === "Guest Already Scanned" && scannedData?.guests?.[0]?.checkOutTime === "" && (
                      <button
                        id="check-out-btn"
                        className="fill-btn-style"
                        onClick={() => checkInAPI(scannedData, 'checkOut')}
                      >
                        CHECK OUT
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="scan-card-container rounded" id="scan-success-card">
            <div className="header-part">
              <div className="d-flex align-items-center">
                <span className="material-symbols-outlined text-success">check_circle</span>
                <div className="text-part">
                  <h6 id="spot-saved-heading" className="s-heading">SPOT SAVED</h6>
                  <p id="party-size-text" className="text-muted">For party of {scannedData?.partySize}</p>
                </div>
              </div>
            </div>
            <div className="body-part">
              <div className="mb-4">
                <p className="day-time-date">Time</p>
                <h6 id="spot-start-time" className="day-time-date-txt">{scannedData?.spotstart}</h6>
              </div>
              <div className="mb-3">
                <p className="day-time-date">Date</p>
                <h6 id="booking-date" className="day-time-date-txt">
                  {scannedData?.bookingDate ? moment.utc(scannedData?.bookingDate).format("MM-DD-YYYY") : ""}
                </h6>
              </div>
            </div>
            <div className="col-md-12" id="checkin-action-buttons">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-center align-items-center">
                    <button id="scan-again-btn-2" className="stroke-btn-style me-3" onClick={scanAgain}>
                      SCAN AGAIN
                    </button>
                    <button
                      id="check-in-btn"
                      className="fill-btn-style"
                      onClick={() => checkInAPI(scannedData, 'checkIn')}
                    >
                      CHECK IN
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

    );
  }




  if (submitted) {
    return (
      <div id="scan-submitted-container">
        <div className="scan-card-success rounded" id="spot-saved-card">
          <div className="header-part" id="spot-saved-header">
            <span className="material-symbols-outlined" id="spot-saved-icon">check_circle</span>
            <h6 className="s-heading" id="spot-saved-title">SPOT SAVED</h6>
          </div>
          <div className="body-part" id="spot-saved-body">
            <span className="material-symbols-outlined" id="confirmation-number-icon">confirmation_number</span>
            <h2 className="party-txt" id="party-size-text">
              PARTY OF <span id="party-size-number">{scannedData?.partySize}</span>
            </h2>
            <p className="checkout-txt" id="ready-checkout-text">Ready to Check-out</p>
          </div>
        </div>
        <div className="col-md-12" id="action-buttons-container">
          <div className="card" id="action-buttons-card">
            <div className="card-body" id="action-buttons-body">
              <div className="d-flex justify-content-center align-items-center" id="action-buttons-flex">
                <button
                  id="scan-again-button"
                  className="stroke-btn-style me-3"
                  onClick={scanAgain}
                >
                  SCAN AGAIN
                </button>
                <button
                  id="check-out-button"
                  className="fill-btn-style"
                  onClick={() => checkInAPI(scannedData, 'checkOut')}
                >
                  CHECK OUT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  let singleCount = (countsData?.walkin || 0) + (countsData?.visitorCount || 0);
  let scannedEqualCount = singleCount >= countsData?.maxVisitor;

  return (
    <div id="scan-video-container">
      {scannedEqualCount ? (
        <div className="col-md-12" id="store-full-message-container">
          <div className="card" id="store-full-card">
            <div className="card-body" id="store-full-body">
              <div
                className="d-flex justify-content-center align-items-center"
                id="store-full-text-container"
              >
                <p className="checkout-txt" id="store-full-text">Store is full</p>
                {/* <button className="stroke-btn-style me-3" onClick={scanAgain}>SCAN AGAIN</button> */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div id="video-wrapper">
          <video
            ref={videoRef}
            autoPlay
            muted
            playsInline
            style={{ width: '100%' }}
            id="scan-video"
          />
          <canvas ref={canvasRef} style={{ display: 'none' }} id="scan-canvas" />
        </div>
      )}

      <SweetAlert
        show={tableErrMsg}
        custom
        confirmBtnText="OK"
        confirmBtnBsStyle="primary"
        title={"Please select store."}
        onConfirm={() => {
          setTableErrMsg(false);
          scanned.current = false;
          startScanner();
          onScanChange(false);
        }}
        id="alert-select-store"
      />

      <SweetAlert
        show={tableErrMsg1}
        custom
        confirmBtnText="OK"
        confirmBtnBsStyle="primary"
        title={"Invalid Scanner. The code you scanned is a different store"}
        onConfirm={() => {
          setTableErrMsg1(false);
          scanned.current = false;
          startScanner();
          onScanChange(false);
        }}
        id="alert-invalid-scanner"
      />

      <SweetAlert
        show={invalidBarcode}
        custom
        confirmBtnText="OK"
        confirmBtnBsStyle="primary"
        title={"Invalid bar code you scanned"}
        onConfirm={() => {
          setInvalidBarcode(false);
          scanned.current = false;
          startScanner();
        }}
        id="alert-invalid-barcode"
      />

      <SweetAlert
        show={scanError}
        custom
        confirmBtnText="OK"
        confirmBtnBsStyle="primary"
        title={scanErrorMsg}
        onConfirm={() => {
          setScanError(false);
          scanned.current = false;
          startScanner();
        }}
        id="alert-scan-error"
      />
    </div>
  );

};

export default ScannerComponent;

